import { apiGet } from "../client";
import type { VarianceAnalysisResponseApi } from "../models/varianceAnalysis";

export async function getVarianceAnalysis(
  period: number,
  snapshotId?: number,
): Promise<VarianceAnalysisResponseApi> {
  const params = new URLSearchParams({ period: period.toString() });
  if (snapshotId !== undefined) {
    params.append("snapshotId", snapshotId.toString());
  }
  return apiGet<VarianceAnalysisResponseApi>(
    `forecast/variance-analysis?${params.toString()}`,
  );
}
